import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
export const contactDetails = (customerSupportText)=>/*#__PURE__*/ _jsx("div", {
        children: customerSupportText != "" ? /*#__PURE__*/ _jsx("div", {
            dangerouslySetInnerHTML: {
                __html: customerSupportText
            }
        }) : /*#__PURE__*/ _jsx(_Fragment, {})
    });
{}